<template>
  <div class="apply">
    <div class="apply-top">
      <div class="apply-top__name">亚马逊商品"站外"推广费用申请</div>
      <div class="apply-top__fun">
        <div class="apply-top-item apply-top-item--date">
          <el-select size="mini" placeholder="全部划款日期"></el-select>
        </div>
        <div class="apply-top-item">
          <el-select size="mini" placeholder="全部国家"></el-select>
        </div>
        <div class="apply-top-item">
          <el-select size="mini" placeholder="全部店铺"></el-select>
        </div>
        <div class="apply-top-item apply-top-item--input">
          <el-input size="mini" placeholder="请输入ASIN,卖家SKU,FNSKU,产品名称等"></el-input>
        </div>
        <div class="apply-top__btn">搜索</div>
        <div class="apply-top__btn" @click="openApplyDialog">新建推广申请单</div>
      </div>
    </div>
    <div class="apply-table">
      <Table :head="feeApplyTableHead" width="1654" height="550"></Table>
    </div>
    <Dialog :show="newFeeApplyDialogShow" @cancel="cancelApplyDialog">
      <div class="apply-dialog">
        <progressBar
          class="apply-dialog-progress"
          :arr="newFeeApplyDialogProgressData"
          :activeIndex="newFeeApplyDialogProgressActiveIndex"></progressBar>
        <div class="apply-dialog-store" v-if="newFeeApplyDialogProgressActiveIndex == 0">
          <div class="apply-dialog-list">
            <div class="apply-dialog-list__name">店铺:</div>
            <el-select size="mini"></el-select>
          </div>
          <div class="apply-dialog-list">
            <div class="apply-dialog-list__name">国家站点:</div>
            <el-select size="mini"></el-select>
          </div>
        </div>
        <div class="apply-dialog-listing" v-else-if="newFeeApplyDialogProgressActiveIndex == 1">
          <div class="apply-dialog-top">
            <div class="apply-dialog-top__name">选择发生“站外推广费用”的商品</div>
            <div class="apply-dialog-top__fun">
              <div class="apply-dialog-top-item">
                <el-input size="mini" placeholder="请输入ASIN,卖家SKU,FNSKU,产品名称等"></el-input>
              </div>
              <div class="apply-dialog-top__btn">搜索</div>
            </div>
          </div>
          <div class="apply-dialog-table">
            <Table height="350" width="1114" :head="listingTableHead" :body="listingTableBody"></Table>
          </div>
        </div>
        <div class="apply-dialog-store" v-if="newFeeApplyDialogProgressActiveIndex == 2">
          <div class="apply-dialog-list">
            <div class="apply-dialog-list__name">费用类型:</div>
            <el-select size="mini"></el-select>
          </div>
          <div class="apply-dialog-list">
            <div class="apply-dialog-list__name">服务供应商:</div>
            <el-select size="mini"></el-select>
          </div>
          <div class="apply-dialog-list">
            <div class="apply-dialog-list__name">申请金额:</div>
            <el-input size="mini" prefix-icon="icon-el-inco-cmoney"></el-input>
          </div>
        </div>
        <div class="apply-dialog-bottom">
          <template v-if="newFeeApplyDialogProgressActiveIndex != 0">
            <div class="apply-dialog__btn" @click="preStep">上一步</div>
          </template>
          <template v-if="newFeeApplyDialogProgressActiveIndex != newFeeApplyDialogProgressData.length - 1">
            <div class="apply-dialog__btn" @click="nextStep">下一步</div>
          </template>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { ServiceSupplierInputBoxNewModule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import Dialog from 'components/common/Dialog'
export default {
  name: 'applicationForExternalExpenses',
  components: {
    Table, Dialog, progressBar
  },
  data(){
    return {
      /**站外费用表头 */
      feeApplyTableHead: ServiceSupplierInputBoxNewModule.NEWFEETABLEHEAD(),
      /**新建推广申请单弹窗 */
      newFeeApplyDialogShow: true,
      listingTableHead: ServiceSupplierInputBoxNewModule.NEWLISTINGTABLEHEAD(),
      listingTableBody: [],
      /**新建推广申请单弹窗进度条数据 */
      newFeeApplyDialogProgressData: ServiceSupplierInputBoxNewModule.NEWPROGRESSARRAY(),
      newFeeApplyDialogProgressActiveIndex: 0,
    }
  },
  methods: {
    /**关闭申请弹窗 */
    cancelApplyDialog(){
      this.newFeeApplyDialogShow = false
      this.newFeeApplyDialogProgressActiveIndex = 0
    },
    /**打开申请弹窗 */
    openApplyDialog(){
      this.newFeeApplyDialogShow = true
    },
    /**上一步 */
    preStep(){
      this.newFeeApplyDialogProgressActiveIndex --
    },
    /**下一步 */
    nextStep(){
      this.newFeeApplyDialogProgressActiveIndex ++
    }
  }
}
</script>

<style lang="scss" scoped>
.apply{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 150px;
        }
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 280px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-dialog{
    width: 1200px;
    &-store{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 500px;
    }
    &-list{
      display: flex;
      align-items: center;
      margin: 10px 0;
      &__name{
        width: 100px;
        text-align: end;
        margin-right: 10px;
      }
      ::v-deep{
        .el-input__inner{
          width: 250px;
        }
        .el-input{
          width: 250px;
        }
      }
    }
    &-top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 2px;
      &__name{
        font-weight: bold;
        font-size: 16px;
        color: black;
      }
      &__fun{
        display: flex;
      }
      &-item{
        display: flex;
        align-items: center;
        margin-left: 10px;
        ::v-deep{
          .el-input__inner{
            width: 300px;
          }
        }
        &__name{
          font-size: 14px;
          margin-right: 5px;
        }
      }
      &__btn{
        line-height: 30px;
        padding: 0 15px;
        color: white;
        background: #00a0c7;
        margin-left: 10px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &-bottom{
      display: flex;
      justify-content: end;
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
